import { branchStorageKey } from "../types/startupConstants";

export const localStorageService = (() => {
    function setItem(key: string, data: string) {
        localStorage.setItem(key, data);
    }

    function getItem(key: string) {
        return localStorage.getItem(key);
    }

    function removeTrailingSlash(url: string | null) {
        if (url?.endsWith("/")) {
            url = url.slice(0, -1);
        }

        return url;
    }

    function getUrl(key: string) {
        let urlString = getItem(key);

        urlString = removeTrailingSlash(urlString);

        return urlString;
    }

    function setUrl(key: string, url: string | null) {
        url = removeTrailingSlash(url);

        if (url) {
            setItem(key, url);
        }
    }

    function clearItem(key: string) {
        localStorage.removeItem(key);
    }

    function clearAll() {
        const branch = localStorage.getItem(branchStorageKey);
        localStorage.clear();
        if (branch) {
            localStorage.setItem(branchStorageKey, branch);
        }
    }

    return {
        setItem: setItem,
        getItem: getItem,
        getUrl: getUrl,
        setUrl: setUrl,
        clearItem: clearItem,
        clearAll: clearAll
    };
})();
